import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import FeaturedList from './FeaturedList';
import UpcomingList from './UpcomingList';
import ListPager from './ListPager';
import Loader from './Loader';
import { AJAX_URL, COOP_ID } from '../../config/index.js';

let pageWasInteractedWith = false;

export default function CoopsList() {
  const [isLoading, setLoading] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [featuredList, setFeaturedList] = useState([]);
  const [query, setQuery] = useState({
    my_coop_id: COOP_ID
  });

  // hacky way to prevent the automatic scroll-trigger to top of container on pageload.. guys..
  $(document).one('click', () => {
    pageWasInteractedWith = true;
  });

  // Pagination State
  const [limit, setLimit] = useState(6);
  const [pagerIndex, setPagerIndex] = useState(0);
  const [paginatedEvents, setPaginatedEvents] = useState([]);
  const [paginatedFeatured, setPaginatedFeatured] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const handlePagination = (list, currentIndex, featured = false) => {
    !featured ? setTotalPages(Math.ceil(list.length / limit)) : '';
    const lastPage = totalPages - 1;

    if (!featured) {
      if (currentIndex >= totalPages) {
        setPagerIndex(0);
        return;
      } else if (currentIndex < 0) {
        setPagerIndex(lastPage);
        return;
      }
    }

    const startIndex = limit * currentIndex;
    const endIndex = startIndex + limit;
    const selection = list.slice(startIndex, endIndex);
    !featured ? setPaginatedEvents(selection) : setPaginatedFeatured(selection);

    // Scroll to top of container after changing pagination (settings).
    if (pagerIndex || (!pagerIndex && pageWasInteractedWith)) {
      const scrollOffset = document.body.classList.contains('admin-bar')
        ? 105
        : 70;

      window.scrollTo({
        top:
          window.pageYOffset +
          parseInt(
            document.getElementById('coops-app').getBoundingClientRect().top
          ) -
          scrollOffset,
        behavior: 'smooth'
      });
    }
  };

  const prevPage = () => {
    setPagerIndex(pagerIndex - 1);
  };

  const nextPage = () => {
    setPagerIndex(pagerIndex + 1);
  };

  useEffect(() => {
    const fetchEvents = async (query) => {
      await $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_wlQueryMyCoop`,
        dataType: 'json',
        encode: true,
        data: query,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => setEventList(res.data))
        .catch((err) => console.log(err.message));
    };
    fetchEvents(query);
    setPagerIndex(0);
  }, [query, limit]);

  const createFeaturedList = (list) => {
    let featuredList = [];
    for (const item of list.slice(0, 2)) {
      featuredList.push(item);
    }
    return featuredList;
  };

  useEffect(() => {
    eventList.length > 0 ? setLoading(false) : '';
    setFeaturedList(createFeaturedList(eventList));
    handlePagination(eventList, pagerIndex);
  }, [eventList]);

  useEffect(() => {
    let eventListNew = eventList.slice(2);
    handlePagination(eventListNew, pagerIndex);
    handlePagination(featuredList, pagerIndex, true);
  }, [pagerIndex, featuredList, limit]);

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <FeaturedList coopArticle={paginatedFeatured} />
          <UpcomingList coopArticle={paginatedEvents} />
          <ListPager
            changeLimit={setLimit}
            limit={limit}
            setPagerIndex={setPagerIndex}
            nextPage={nextPage}
            prevPage={prevPage}
            pagerIndex={pagerIndex}
            totalEvents={eventList.length}
            totalPages={totalPages}
            paginatedItemCount={paginatedEvents.length}
          />
        </div>
      )}
    </div>
  );
}
